import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const staticSitesListState = (state: AppState) => state.contentManagement.staticSites.staticSitesList;

export const staticSitesListItemsSelector = createSelector(staticSitesListState, state => state.items);
export const staticSitesListRequestingSelector = createSelector(staticSitesListState, state => state.requesting);
